export default "__VITE_ASSET__3ac7c267__"